/*
 * yojo-upsell-metrics.js — exposure + interaction layer for the basket-building
 * system (closure sprint 2026-08-08).
 *
 * Two halves of the measurement story:
 *   1. ORDER TRUTH (not this file): every upsell add carries the hidden
 *      line-item property `_yojo_src`, so attachment is read from orders,
 *      immune to consent state.
 *   2. FUNNEL CONTEXT (this file): impression + click events for the same
 *      surfaces, pushed to the GTM dataLayer exactly like
 *      yojo-analytics-events.js does, so exposure -> click -> add can be
 *      ratioed in GA4.
 *
 * Surfaces observed (same tokens as `_yojo_src`):
 *   companions      [data-yojo-companions]        PDP companion strip
 *   moment-band     [data-yojo-moment-band]       PDP moment band (+ data-moment)
 *   gift-threshold  [data-yojo-gift-threshold]    cart gift nudge
 *   stock-rail      .yojo-cart-stock-rail         empty-cart rail
 *
 * One impression per surface per page load (the cart subtotal re-renders on
 * every mutation; re-observing it would inflate impressions, so a surface
 * key fires once). Clicks are counted on any interactive element inside the
 * surface. No PII, no per-customer state, nothing stored.
 */
(function () {
  'use strict';

  var SURFACES = [
    { sel: '[data-yojo-companions]', src: 'companions' },
    { sel: '[data-yojo-bundle-builder]', src: 'bundle-builder' },
    { sel: '[data-yojo-moment-band]', src: 'moment-band' },
    { sel: '[data-yojo-gift-threshold]', src: 'gift-threshold' },
    { sel: '.yojo-cart-stock-rail', src: 'stock-rail' },
  ];

  var seenImpression = {};

  function dl(obj) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(obj); } catch (e) {}
  }

  function payload(kind, src, el) {
    var p = { event: kind, upsell_surface: src, page_path: location.pathname };
    var moment = el && el.getAttribute && el.getAttribute('data-moment');
    if (moment) p.upsell_moment = moment;
    return p;
  }

  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var src = el.getAttribute('data-yojo-metrics-src');
          if (!src || seenImpression[src]) return;
          seenImpression[src] = true;
          dl(payload('yojo_upsell_impression', src, el));
          io.unobserve(el);
        });
      }, { threshold: 0.4 })
    : null;

  function scan(root) {
    SURFACES.forEach(function (s) {
      var nodes = (root || document).querySelectorAll(s.sel);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.hasAttribute('data-yojo-metrics-src')) continue;
        el.setAttribute('data-yojo-metrics-src', s.src);
        if (io && !seenImpression[s.src]) io.observe(el);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('button, a, input[type="submit"]');
    if (!t) return;
    var host = t.closest('[data-yojo-metrics-src]');
    if (!host) return;
    dl(payload('yojo_upsell_click', host.getAttribute('data-yojo-metrics-src'), host));
  }, true);

  function boot() {
    scan(document);
    // The drawer subtotal (#AjaxCartSubtotal) and drawer body re-render on
    // every cart mutation; rescan when subtree HTML is replaced so late
    // surfaces still get tagged (impressions stay once-per-page via seenImpression).
    if ('MutationObserver' in window) {
      new MutationObserver(function () { scan(document); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
